import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/public/security/Login.vue'),
    meta: { layout: 'full-width-layout', private: false }
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/private/home/Home.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizaciones',
    name: 'Quotes',
    component: () => import('@/views/private/quotes/Quotes.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/ordenes',
    name: 'WorkOrders',
    component: () => import('@/views/private/work-orders/WorkOrders.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizacion-proyecto',
    name: 'NewProjectQuote',
    component: () => import('@/views/private/project-quote/ProjectQuote.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizacion-proyecto/:id',
    name: 'EditProjectQuote',
    component: () => import('@/views/private/project-quote/ProjectQuote.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizacion-staff',
    name: 'NewStaffQuote',
    component: () => import('@/views/private/staff-quote/StaffQuote.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizacion-staff/:id',
    name: 'EditStaffQuote',
    component: () => import('@/views/private/staff-quote/StaffQuote.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/cotizacion-soporte/:id?',
    name: 'SupportQuote',
    component: () => import('@/views/private/support-quote/SupportQuote.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/tarifas',
    name: 'Rates',
    component: () => import('@/views/private/rates/Rates.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/proyectos',
    name: 'Projects',
    component: () => import('@/views/private/projects/Projects.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/proyecto/:projectId/ordenes-trabajo-proyecto',
    name: 'ProjectWorkOrders',
    component: () =>
      import(
        '@/views/private/project/project-work-orders/ProjectWorkOrders.vue'
      ),
    meta: { layout: 'project-layout', private: true }
  },
  {
    path: '/orden-trabajo-pwo/:id',
    name: 'ProjectWorkOrder',
    component: () =>
      import('@/views/private/project-work-order/ProjectWorkOrder.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/orden-trabajo-swo/:id',
    name: 'StaffWorkOrder',
    component: () =>
      import('@/views/private/staff-work-order/StaffWorkOrder.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/orden-trabajo-spwo/:id',
    name: 'SupportWorkOrder',
    component: () =>
      import('@/views/private/support-work-order/SupportWorkOrder.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/facturas',
    name: 'Invoices',
    component: () => import('@/views/private/invoices/Invoices'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-spwo',
    name: 'CreateInvoiceSupportWorkOrder',
    component: () => import('@/views/private/invoice-support-work-order/InvoiceSupportWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-spwo/:id',
    name: 'EditInvoiceSupportWorkOrder',
    component: () => import('@/views/private/invoice-support-work-order/InvoiceSupportWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-swo',
    name: 'CreateInvoiceStaffWorkOrder',
    component: () => import('@/views/private/invoice-staff-work-order/InvoiceStaffWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-swo/:id',
    name: 'EditInvoiceStaffWorkOrder',
    component: () => import('@/views/private/invoice-staff-work-order/InvoiceStaffWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-pwo',
    name: 'CreateInvoiceProjectWorkOrder',
    component: () => import('@/views/private/invoice-project-work-order/InvoiceProjectWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/factura-pwo/:id',
    name: 'EditInvoiceProjectWorkOrder',
    component: () => import('@/views/private/invoice-project-work-order/InvoiceProjectWorkOrder'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/proyecto/:projectId/ordenes-trabajo-staff',
    name: 'StaffWorkOrders',
    component: () =>
      import('@/views/private/project/staff-work-orders/StaffWorkOrders.vue'),
    meta: { layout: 'project-layout', private: true }
  },
  {
    path: '/usuarios',
    name: 'Users',
    component: () => import('@/views/private/users/Users.vue'),
    meta: { layout: 'main-layout', private: true }
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/pages/Error404.vue'),
    meta: { layout: 'error-page-layout', private: false }
  },
  {
    path: '*',
    redirect: '/error-404'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, source, next) => {
  let authenticated = false

  const user = JSON.parse(localStorage.getItem('user'))
  if (user) {
    if (user.token) {
      authenticated = true
    }
  }

  if (to.meta.private && !authenticated) {
    next({ name: 'Login' })
  } else if (to.name === 'Login' && authenticated) {
    next({ name: 'Projects' })
  } else {
    next()
  }
})

export default router
